/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
// import { authHeader } from '../../_helpers';
import {
  Grid,
  Segment,
  Header,
  Icon,
  Message,
  Dropdown,
  Divider,
  Table,
  Tab,
  TextArea,
  Accordion,
  Input,
  Modal
} from 'semantic-ui-react';
import {
  Button,
  Form,
  Input as FormikInput
} from 'formik-semantic-ui';
import { UnsavedFormPrompt } from '../../_components/custom/UnsavedFormPropt';
import { setToast } from '../../store/ToastManagement';
import { history } from '../../_helpers';
import {
  dbUTCDatetimeToLocal,
  copyToClipboard,
  brandedCustomerType,
  polyFillStructuredClone,
  cloudLogLink,
  displayLanceID,
  chargingTypeOptions
} from '../../utils';
import {
  servicesAPI,
  useCurrentUser,
  useCustomer,
  useCustomerPreferences,
  useExternalAccounts,
  useCustomerVehicles,
  useReferenceVehicles
} from '../../_services';
import { CustomerContact, CardDetails } from '../../_components/users/';
import './customerDetail_styles.css';

const countOptions = [
  { text: '10', value: 10 },
  { text: '25', value: 25 },
  { text: '50', value: 50 },
  { text: '100', value: 100 },
  { text: '200', value: 200 }
];

export const DisplayCustomer = () => {
  const { id } = useParams();
  const isNew = id === '0';

  const { currentUser, currentUserCan, currentUserIsDebug, impersonateCustomer } = useCurrentUser();

  const canEdit = currentUserCan('ManageCustomer');
  const canViewAsCustomer = currentUserCan('ViewAsCustomer');
  const canDeactivate = currentUserCan('DeactivateCustomer');

  const [contract, setContract] = useState(null);
  const { customerVehicles } = useCustomerVehicles(id);
  const [tabIndex, setTabIndex] = useState(0);
  const [accountData, setAccountData] = useState([]);
  const [contractData, setContractData] = useState([]);
  const [aonSignUpState, setAonSignUpState] = useState(null);
  const [notes, setNotes] = useState('');

  const referenceVehicles = useReferenceVehicles();
  const { externalAccounts, setExternalAccounts } = useExternalAccounts(id);

  const [cbTouched, setCBTouched] = useState(false);

  const [customer, setCustomer] = useState(null);
  const [aonTariffName, setAonTariffName] = useState('');
  const [aonTariffRate, setAonTariffRate] = useState('');
  const [customerTypes, setCustomerTypes] = useState([]);
  const [customerType, setCustomerType] = useState(null);
  const [installationPaymentPounds, setInstallationPaymentPounds] = useState(0);
  const [initialPaymentPounds, setInitialPaymentPounds] = useState(0);
  const [monthlyPaymentPounds, setMonthlyPaymentPounds] = useState(0);
  const [minimumTermMonths, setMinimumTermMonths] = useState(0);
  const [chargingCredit, setChargingCredit] = useState(false);
  // const [homeMoveTerminationFee, setHomeMoveTerminationFee] = useState(0); // TDTODO
  // const [monthlyChargingAllowance, setMonthlyChargingAllowance] = useState(0); // TDTODO

  const [initVehicles, setInitVehicles] = useState(true);
  const [externalCompanyId, setExternalCompanyId] = useState('');
  const [externalCompanyAccountNo, setExternalCompanyAccountNo] = useState('');
  const [editVehicles, setEditVehicles] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState(0);
  const [editMake, setEditMake] = useState(null);
  const [editModel, setEditModel] = useState(null);
  const [editVariant, setEditVariant] = useState(null);
  const [editRegistration, setEditRegistration] = useState('');
  const [dvlaTax, setDvlaTax] = useState('');
  const [dvlaMOT, setDvlaMOT] = useState('');
  const [lanceToCustomers, setLanceToCustomers] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [sessionData, setSessionData] = useState([]);
  const [phalanxes, setPhalanxes] = useState([]);
  const [lances, setLances] = useState([]);
  const [customerToLances, setCustomerToLances] = useState([]);
  const [numSessions, setNumSessions] = useState(10);
  const [activity, setActivity] = useState([]);
  const [hasActiveLance, setHasActiveLance] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deactivatedReason, setDeactivatedReason] = useState('');

  const isSignUp = customer && customer.status === 'Signup';
  const name =
    customer && customer.id ? customer.forename + ' ' + customer.surname : '-';

  // TDTODO replace with new T&Cs when ready
  const isPaulBragg =
    customer?.id === 'CCCR056d81a0-02cb-405c-a34d-22f622158ecd';
  const paysByCard = !isPaulBragg;

  const {
    customerPreferences,
    setCustomerPreferences
  } = useCustomerPreferences(customer?.id);

  useEffect(() => {
    servicesAPI.CustomerServices('getTypes').then(types => {
      setCustomerTypes(types);

      if (!isNew) {
        servicesAPI.CustomerServices('getById', id).then(customer => {
          // customer.lat_lon.lat
          // customer.lat_lon.lon

          setCustomer(customer);
          setCustomerType(customer.customer_type);

          if (brandedCustomerType(customer.customer_type) === 'HOME' && !aonSignUpState) {
            servicesAPI
              .AdminServices('getEntityState', 'AON_SIGN_UP', customer.id)
              .then(state => {
                setAonSignUpState(state);
                if (state?.flatpeak_id) getAonEnergyTariff(state.flatpeak_id);
              });
          }

          const count = 50;
          servicesAPI
            .AdminServices('getUserActivitiesByType', customer.user_id, 'ALL', count)
            .then(activities => setActivity(activities));
        });
      } else {
        // Default to most recent project
        setCustomerType(types[0].name);
        setCustomer({
          status: 'Signup',
          password: '',
          customer_type: types[0].name,
          terms_document_id: '',
          title: '',
          forename: '',
          surname: '',
          email: '',
          home_tel_no: '',
          mob_tel_no: '',
          address_line1: '',
          address_line2: '',
          address_city: '',
          address_country_region: '',
          address_county: '',
          address_postcode: '',
          agreed_to_terms_datetime: '',
          notes: '',
          created_datetime: '',
          last_logon_datetime: ''
        });
      }
    });

    servicesAPI.AdminServices('getContract', id).then(contract => setContract(contract));

    getLanceToCustomers(id);

    if (!isNew && id) {
      servicesAPI
        .CustomerServices('getLanceCustomerIdsByCustomer', id)
        .then(customerToLances => {
          setCustomerToLances(customerToLances);

          const lanceIds = customerToLances.map(s => s.lance_tag_id);
          if (!lanceIds.length) return;

          const values = {
              lance_ids: lanceIds
          };
          servicesAPI
            .InventoryServices('getLancesByIds', values)
            .then(lances => {
              setLances(lances);
            });
        });
    }
  }, [id]);

  useEffect(() => {
    if (!customer || !customerPreferences) return;

    let accountData = [
      {
        property: 'Account Type',
        value: brandedCustomerType(customer.customer_type)
      },
      {
        property: 'Status',
        value: customer.status
      },
      {
        property: 'Signup timestamp',
        value: dbUTCDatetimeToLocal(customer.created_datetime)
      },
      {
        property: 'Agreed to T&Cs',
        value: dbUTCDatetimeToLocal(customer.agreed_to_terms_datetime)
      },
      {
        property: 'Last login to customer portal',
        value: dbUTCDatetimeToLocal(customer.last_logon_datetime)
      }
    ];
    if (currentUserIsDebug) {
      accountData.push(      {
        property: 'Last login browser user agent',
        value: customerPreferences?.pref_user_agent
      });
    }
    accountData.push(      {
      property: 'Signed up to app?',
      value: customer.app_user ? 'Yes' : 'No'
    });
    setAccountData(accountData);

	    if (brandedCustomerType(customerType) === 'HOME' && !aonSignUpState) return;

    let initialPayment = 'Initial Payment';
    if (brandedCustomerType(customerType) === 'HOME')
      initialPayment = 'Initial Payment';
    else if (brandedCustomerType(customerType) === 'HUB: Camden phase 1' || brandedCustomerType(customerType) === 'HUB: Camden phase 2')
      initialPayment = 'Lance Deposit';
    else if (brandedCustomerType(customerType) === 'HUB: Brent')
      initialPayment = 'Lance Deposit';
    else if (brandedCustomerType(customerType) === 'HUB: Harrow' || brandedCustomerType(customerType) === 'HUB: Bexley')
      initialPayment = 'Charging Credit';
    else if (brandedCustomerType(customerType) === 'HUB: Barnet phase 1' || brandedCustomerType(customerType) === 'HUB: Barnet phase 2')
      initialPayment = 'Charging Credit';

    let contractData = []

    if (brandedCustomerType(customerType) === 'HOME') {
      let paid = aonSignUpState?.initial_payment_paid ? ' (PAID)' : '';
      contractData.push({
        property: initialPayment,
        value: contract ? `£${contract.initial_payment_amount / 100} ${paid}` : '?'
      });

      contractData.push({
        property: 'Installation Supplement',
        value: contract ? '£' + contract.installation_payment_amount / 100 : '?'
      });

      contractData.push({
        property: 'Monthly Payment',
        value: contract ? '£' + contract.monthly_payment_amount / 100 : '£' + aonSignUpState.subscription_fee_pounds + ' (selected in sign-up, not yet contractual)'
      });

      contractData.push({
        property: 'Minimum Term',
        value: contract ? contract.minimum_term_months + ' months' : aonSignUpState.initial_term_months + ' months (selected in sign-up, not yet contractual)'
      });

      contractData.push({
        property: 'Local Council',
        value: aonSignUpState ? aonSignUpState.local_authority : '?'
      });

      contractData.push({
        property: 'HOME Approved by Trojan',
        value: aonSignUpState ? aonSignUpState.postcode_approved ? 'Approved' : 'Rejected' : '?'
      });

      contractData.push({
        property: 'HOME Approved by Local Council',
        value: aonSignUpState ? aonSignUpState.postcode_approved_by_council ? 'Approved' : 'Rejected' : '?'
      });

      if (aonSignUpState?.postcode_approved) {
        let type = aonSignUpState?.self_survey ? 'Customer performing survey' : aonSignUpState?.self_survey === false ? 'Trojan performing survey' : '?';
        let completed = aonSignUpState?.survey_completed ? ' (COMPLETED)' : '';
        contractData.push({
          property: 'HOME Survey',
          value: aonSignUpState ? `${type} ${completed}` : '?'
        });

        let status = '?';
        if (aonSignUpState?.approved_for_aon === true) status = 'APPROVED';
        else if (aonSignUpState?.approved_for_aon === false) status = 'REJECTED';
        else if (aonSignUpState.submitted_for_approval === true) status = 'SUBMITTED';

        contractData.push({
          property: 'HOME Application Status',
          value: status
        });

        contractData.push({
          property: 'Domestic Energy Tariff',
          value: aonTariffName ? `${aonTariffName} (${aonTariffRate} / kWh)` : 'Unknown'
        });

        const chargingType = chargingTypeOptions.find(o => customerPreferences?.pref_charging_type === o.value);
        const chargeAfterOffPeakEnds = customerPreferences?.pref_charging_type === 'Cheapest' && customerPreferences?.pref_cheapest_tariff === false ? ', but continue charging when off peak ends' : '';

        contractData.push({
          property: 'Charging Type',
          value: chargingType ? `${chargingType.text}${chargeAfterOffPeakEnds}` : 'Unknown'
        });

        if (customerPreferences?.pref_charging_type === 'Cheapest') {
          contractData.push({
            property: 'Weekday Charging Period 1',
            value: customerPreferences?.pref_weekday_charging_times_1
          });
          contractData.push({
            property: 'Weekday Charging Period 2',
            value: customerPreferences?.pref_weekday_charging_times_2
          });
          contractData.push({
            property: 'Weekend Charging Period 1',
            value: customerPreferences?.pref_weekend_charging_times_1
          });
          contractData.push({
            property: 'Weekend Charging Period 2',
            value: customerPreferences?.pref_weekend_charging_times_2
          });
        }
      }
    } else {
      contractData.push({
        property: initialPayment,
        value: contract ? `£${contract.initial_payment_amount / 100}` : '?'
      });

      const chargingType = chargingTypeOptions.find(o => customerPreferences?.pref_charging_type === o.value);
      const chargeAfterOffPeakEnds = customerPreferences?.pref_charging_type === 'Cheapest' && customerPreferences?.pref_cheapest_tariff === false ? ', but continue charging when off peak ends' : '';

      contractData.push({
        property: 'Charging Type',
        value: chargingType ? `${chargingType.text}${chargeAfterOffPeakEnds}` : 'Unknown'
      });
    }

    setContractData(contractData);

    setNotes(customer.notes);
  }, [customer, contract, customerType, customerPreferences, aonSignUpState, aonTariffName, aonTariffRate]);

  useEffect(() => {
    if (brandedCustomerType(customerType) === 'HOME') {
      setInstallationPaymentPounds(0);
      setInitialPaymentPounds(99);
      setMonthlyPaymentPounds(99);
      setMinimumTermMonths(36);
      setChargingCredit(false);
    } else if (brandedCustomerType(customerType) === 'HUB: Camden phase 1' || brandedCustomerType(customerType) === 'HUB: Camden phase 2') {
      setInstallationPaymentPounds(0);
      setInitialPaymentPounds(0);
      setMonthlyPaymentPounds(0);
      setMinimumTermMonths(0);
      setChargingCredit(false);
    } else if (brandedCustomerType(customerType) === 'HUB: Brent') {
      setInstallationPaymentPounds(0);
      setInitialPaymentPounds(0);
      setMonthlyPaymentPounds(0);
      setMinimumTermMonths(0);
      setChargingCredit(false);
    } else if (brandedCustomerType(customerType) === 'HUB: Harrow' || brandedCustomerType(customerType) === 'HUB: Bexley') {
      setInstallationPaymentPounds(0);
      setInitialPaymentPounds(0);
      setMonthlyPaymentPounds(0);
      setMinimumTermMonths(0);
      setChargingCredit(false);
    } else if (brandedCustomerType(customerType) === 'HUB: Barnet phase 1' || brandedCustomerType(customerType) === 'HUB: Barnet phase 2') {
      setInstallationPaymentPounds(0);
      setInitialPaymentPounds(0);
      setMonthlyPaymentPounds(0);
      setMinimumTermMonths(0);
      setChargingCredit(false);
    }
  }, [customerType]);

  useEffect(() => {
    if (externalAccounts && externalAccounts.length > 0) {
      setExternalCompanyId(externalAccounts[0].external_company_id);
      setExternalCompanyAccountNo(externalAccounts[0].external_account_number);
    }
  }, [externalAccounts]);

  useEffect(() => {
    if (customerVehicles && referenceVehicles.length) {
      setEditVehicles(
        customerVehicles.concat([
          {
            id: '',
            vehicle_id: '',
            registration_no: ''
          }
        ])
      );
    }
  }, [customerVehicles, referenceVehicles]);

  const selectVehicle = idx => {
    if (!referenceVehicles.length || !editVehicles) return;

    const rvs = referenceVehicles.filter(
      rv => rv.id === editVehicles[idx].vehicle_id
    );
    if (rvs.length === 1) {
      setEditMake(rvs[0].make);
      setEditModel(rvs[0].model);
      setEditVariant(rvs[0].id);
    } else {
      setEditMake('');
      setEditModel('');
      setEditVariant('');
    }
    setEditRegistration(editVehicles[idx].registration_no);
  };

  useEffect(() => {
    if (initVehicles && referenceVehicles.length && editVehicles) {
      setInitVehicles(false);
      selectVehicle(selectedVehicle);
    }
  }, [initVehicles, editVehicles, selectedVehicle, referenceVehicles]); // eslint-disable-line

  useEffect(() => {
    if (!sessions.length) return;

    const phalanxIds = sessions.map(s => s.phalanx_tag_id);
    if (!phalanxIds.length) return;

    const values = {
        phalanx_ids: phalanxIds
    };
    servicesAPI
      .InventoryServices('getPhalanxesByIds', values)
      .then(phalanxes => setPhalanxes(phalanxes));
  }, [sessions]);

  useEffect(() => {
    if (!sessions.length || !phalanxes.length) return;

    setSessionData(
      sessions.map(s => {
        const start = s.timestamp ? dbUTCDatetimeToLocal(s.timestamp) : '';
        const end = s.stop_timestamp
          ? dbUTCDatetimeToLocal(s.stop_timestamp)
          : '';

        const phalanx = phalanxes.find(p => p.tag_id === s.phalanx_tag_id);
        const location = phalanx ? `${phalanx.description} CS${phalanx.reference.slice(-2)}` : `Phalanx ${s.phalanx_tag_id}`;
        return {
          ...s,
          start: start,
          end: end,
          location: location
        };
      })
    );
  }, [sessions, phalanxes]);

  async function getLanceToCustomers(customerId) {
    const lanceToCustomers = await servicesAPI.CustomerServices(
      'getLanceCustomerIdsByCustomer',
      customerId
    );
    setLanceToCustomers(lanceToCustomers);

    let hasActiveLance = false;
    lanceToCustomers.forEach(ltc => {
      if (ltc.status === 'ACTIVE') hasActiveLance = true;
    });
    setHasActiveLance(hasActiveLance);
  }

  async function getSessions(lanceToCustomerIds, page, size) {
    try {
      const data = {
        ids: lanceToCustomerIds
      };
      const response = await servicesAPI.MeteringServices(
        'getSessionsByLanceToCustomerIds',
        data,
        page,
        size,
        false
      );
      setSessions(response);
    } catch (error) {}
  }

  useEffect(() => {
    // Load charging history
    if (tabIndex === 1 && lanceToCustomers.length) {
      const lanceToCustomerIds = lanceToCustomers.map(ltc => ltc.id);
      getSessions(lanceToCustomerIds, 1, numSessions);
    }
  }, [lanceToCustomers, numSessions, tabIndex]);

  const dispatch = useDispatch();
  const displayMessage = (title, message, success) =>
    dispatch(
      setToast({
        title: title,
        success: success,
        body: message
      })
    );

  const getAonEnergyTariff = locationId => {
    servicesAPI
      .MeteringServices('getFlatpeakTariff', locationId)
      .then(tariff => {
        const rate = tariff.rate.toFixed(2);

        setAonTariffName(tariff.name);
        setAonTariffRate(`£${rate}`);
      });
  };

  if (!customerVehicles || !externalAccounts) {
    return <div>Loading</div>;
  }

  const vehicleOptions = customerVehicles
    .map((v, idx) => {
      let text = v.registration_no;
      if (referenceVehicles) {
        const rvs = referenceVehicles.filter(rv => rv.id === v.vehicle_id);
        if (rvs.length === 1) {
          text = `${v.registration_no} ${rvs[0].make} ${rvs[0].model} ${rvs[0].variant}`;
        }
      }
      return {
        text: text,
        value: idx
      };
    })
    .concat([
      {
        text: 'Register new vehicle',
        value: customerVehicles.length
      }
    ]);

  const makeOptions = referenceVehicles
    .map(v => v.make)
    .filter((v, idx, self) => self.indexOf(v) === idx)
    .map(v => {
      return {
        text: v,
        value: v
      };
    });

  const modelOptions = editMake
    ? referenceVehicles
        .filter(v => v.make === editMake)
        .map(v => v.model)
        .filter((v, idx, self) => self.indexOf(v) === idx)
        .map(v => {
          return {
            text: v,
            value: v
          };
        })
    : [];

  const variantOptions =
    editMake && editModel
      ? referenceVehicles
          .filter(v => v.make === editMake && v.model === editModel)
          .filter((v, idx, self) => self.indexOf(v) === idx)
          .map(v => {
            return {
              text: v.variant,
              value: v.id
            };
          })
      : [];

  const _handleSubmit = (values, formikApi) => {
    if (isNew) createCustomer(values, formikApi);
    else updateCustomer(values, formikApi);
  };

  const createCustomer = (values, formikApi) => {
    const customerData = {
      ...values,
      customer_type: customerType,
      notes: notes
    };

    servicesAPI.CustomerServices('signup', customerData).then(
      customer => {
        const customerId = customer['id'];

        // Create contract
        let values = {
          installation_payment_amount: installationPaymentPounds * 100,
          initial_payment_amount: initialPaymentPounds * 100,
          monthly_payment_amount: monthlyPaymentPounds * 100,
          minimum_term_months: minimumTermMonths,
          charging_credit: chargingCredit
        };
        servicesAPI.AdminServices('createContract', values, customerId);

        values = {
          external_company_id: externalCompanyId,
          external_account_number: externalCompanyAccountNo,
          account_purpose: ''
        };

        servicesAPI.CustomerServices('updateExternalAccounts', values, customerId).then(
          response => {
            setExternalAccounts(values);

            values = editVehicles;

            servicesAPI.CustomerServices('updateVehicles', values, customerId).then(
              response => {
                displayMessage('Success', 'Customer created!');
                setCBTouched(false);
                formikApi.resetForm();

                const { from } = {
                  from: { pathname: `/admin/customer/${customerId}` }
                };
                history.push(from);
              },
              error => {
                displayMessage('Error', `Failed to create customer vehicles! (${error})`);
                formikApi.setSubmitting(false);
                formikApi.setStatus({ error: error });
              }
            );
          },
          error => {
            displayMessage('Error', `Failed to create customer external accounts! (${error})`);
            formikApi.setSubmitting(false);
            formikApi.setStatus({ error: error });
          }
        );
      },
      error => {
        displayMessage('Error', `Failed to create customer! (${error})`);
      }
    );
  };

  const updateCustomer = (values, formikApi) => {
    values = {
      ...values,
      notes: notes,
      id
    };

    servicesAPI.CustomerServices('update', values, id).then(
      response => {
        setCustomer(values);

        values = {
          external_company_id: externalCompanyId,
          external_account_number: externalCompanyAccountNo,
          account_purpose: ''
        };

        servicesAPI.CustomerServices('updateExternalAccounts', values, id).then(
          response => {
            setExternalAccounts(values);

            values = editVehicles;

            servicesAPI.CustomerServices('updateVehicles', values, id).then(
              response => {
                displayMessage('Success', 'Account changes successfully saved');
                setCBTouched(false);
                formikApi.resetForm();
              },
              error => {
                formikApi.setSubmitting(false);
                formikApi.setStatus({ error: error });
              }
            );
          },
          error => {
            formikApi.setSubmitting(false);
            formikApi.setStatus({ error: error });
          }
        );
      },
      error => {
        formikApi.setSubmitting(false);
        formikApi.setStatus({ error: error });
      }
    );
  };

  const inviteCustomer = id => {
    servicesAPI.CustomerServices('invite', id).then(
      response => {
        displayMessage('Success', 'Customer email invite sent', true);
        servicesAPI.AdminServices('auditUserActivity', { entity_type: 'CUSTOMER', entity_id: customer.id, activity: 'CustomerEmail', notes: `Invite to activate account sent`, email_subject: '', email_body: '' }, currentUser.id);
      },
      error => {
        displayMessage('Error', 'Failed to invite customer', false);
      }
    );
  };

  const activateCustomer = id => {
    servicesAPI.CustomerServices('activate', id, 'none').then(
      response => {
        servicesAPI.AdminServices('auditUserActivity', { entity_type: 'CUSTOMER', entity_id: customer.id, activity: 'CustomerActivate', notes: `Customer activated`, email_subject: '', email_body: '' }, currentUser.id);
        displayMessage('Success', 'Customer activated', true);
      },
      error => {
        displayMessage('Error', 'Failed to activate customer', false);
      }
    );
  };

  const deactivateCustomer = id => {
    const values = {
      'deactivated_reason': deactivatedReason
    }
    servicesAPI.CustomerServices('deactivate', id, values).then(
      response => {
        let newCustomer = polyFillStructuredClone(customer);
        newCustomer.status = 'Inactive';
        setCustomer(newCustomer);

        servicesAPI.AdminServices('auditUserActivity', { entity_type: 'CUSTOMER', entity_id: customer.id, activity: 'CustomerDeactivate', notes: `Customer deactivated`, email_subject: '', email_body: '' }, currentUser.id);
        displayMessage('Success', 'Customer deactivated', true);
      },
      error => {
        displayMessage('Error', 'Failed to deactivate customer', false);
      }
    );
  };

  const viewAsCustomer = customer => {
    impersonateCustomer(customer);
    history.push(`/`);
  };

  const handleTabChange = (e, { activeIndex }) => setTabIndex(activeIndex);

  const handleHubSpotPaste = event => {
    const endToken = 'How did you first hear about Trojan HUB';
    const pairs = [
      [ 'first name:', 'forename' ],
      [ 'last name:', 'surname' ],
      [ 'phone number:', 'mob_tel_no' ],
      [ 'email:', 'email' ],
      [ 'street address:', 'address_line1' ],
      [ 'post code:', 'address_postcode' ],
      [ 'ev make and model:', 'ev_make_modal' ],
      [ 'ev registration number:', 'ev_registration' ]
    ];

    let newCustomer = polyFillStructuredClone(customer);

    let parsing = true;
    let field = '';

    const text = event.clipboardData.getData('text');
    const lines = text.split(/\r?\n|\r|\n/g);

    lines.forEach(line => {
      if (line.startsWith(endToken)) parsing = false;

      if (parsing) {
        if (!field) {
          const pair = pairs.find(p => line.toLowerCase().startsWith(p[0]));
          if (pair) field = pair[1];
        } else if (line.trim() !== '') {
          newCustomer[field] = line;
          field = '';
        }
      }
    });

    setCustomer(newCustomer);
    if (newCustomer.ev_registration) {
      setEditRegistration(newCustomer.ev_registration);
      getVehicleDetails(newCustomer.ev_registration, true);
    }

    event.preventDefault();
  };

  const getVehicleDetails = (registration, populate) => {
    servicesAPI
      .AdminServices('getDVLACheck', registration)
      .then(response => {
        const tax = response.taxStatus + (response.taxDueDate ? ` (due ${response.taxDueDate})` : '');
        const mot = response.motStatus + (response.motExpiryDate ? ` (expires ${response.motExpiryDate})` : '');

        setDvlaTax(tax);
        setDvlaMOT(mot);

        // Populate form from DVLA?
        if (populate) {
          const vehicles = referenceVehicles.filter(v => v.make.toUpperCase() === response.make);
          if (vehicles.length) {
            setEditMake(vehicles[0].make);
            setEditModel('');
            setEditVariant('');

            // TDTODO attempt to discern model/variant from newCustomer.ev_make_modal with response.yearOfManufacture
          }
        }
      });
  };

  const pendingStatus = timestamp => {
    const str = dbUTCDatetimeToLocal(timestamp);
    return str ? str : <p style={{ color: 'red' }}>Pending</p>;
  };

  const goToCloudLogLink = (phalanxTagId, datetime) => {
    servicesAPI.InventoryServices('getPhalanx', phalanxTagId).then(phalanx => {
      const url = cloudLogLink(datetime, phalanx.reference);
      window.open(url, '_blank');
    });
  };

  const displayLanceIdAndStatus = (lanceTagId, toDatetime, lanceCustomerStatus, lances) => {
    const lance = lances.find(l => l.tag_id === lanceTagId);
    if (!lance) return '';

    const lanceInfo = `${lance.reference} (${lance.lance_version})`;

    if (toDatetime || !lanceCustomerStatus) return lanceInfo;
    if (lance.status === 'Blocked') return <p style={{ color: 'red' }}>{lanceInfo + ' - BLOCKED'}</p>;
    return lanceInfo + ' - ACTIVE';
  };

  if (!customer) return <div>Loading...</div>;

  return (
    <div>
      <Tab
        menu={{ secondary: true, pointing: true, tabular: false }}
        onTabChange={handleTabChange}
        panes={[
          {
            menuItem: 'Profile',
            render: () => (
              <Tab.Pane attached={false}>
                <Grid centered padded>
                  <Grid.Column>
                    <Form
                      ignoreLoading
                      onSubmit={_handleSubmit}
                      initialValues={customer}
                      enableReinitialize={true}
                    >
                      {({
                        values,
                        errors,
                        status,
                        touched,
                        isSubmitting,
                        handleChange,
                        setFieldValue,
                        values: customer
                      }) => (
                        <div
                          style={{
                            marginBottom: '60px',
                            minHeight: '660px',
                            paddingLeft: '40px',
                            paddingRight: '40px',
                            paddingBottom: '40px'
                          }}
                        >
                        <Form.Children>
                          <Segment>
                            <UnsavedFormPrompt
                              when={!!Object.keys(touched).length || cbTouched}
                            />
                            <Grid columns={2}>
                              <Grid.Row>
                                <Grid.Column>
                                  <Header as="h2">
                                    {isNew
                                      ? 'New Customer'
                                      : `Customer: ${name}`}
                                  </Header>
                                  {!isNew ?
                                    'Please fill out as much information as possible, though only the email address, first/last names, and mobile phone number are essential.' : ''}
                                  <br />
                                  {!!Object.keys(errors).length && (
                                    <>
                                      <Message negative visible>
                                        Please correct requirements in the form
                                      </Message>
                                      <Divider hidden />
                                    </>
                                  )}
                                  <Header as="h3">
                                    <Icon name="table" />
                                    Account
                                  </Header>
                                  {!isNew && (
                                    <Table
                                      basic="very"
                                      selectable
                                      stackable
                                      renderBodyRow={({ property, value }) => ({
                                        key: id,
                                        cells: [
                                          {
                                            key: 'property',
                                            onClick: () => {
                                              copyToClipboard(property);
                                            },
                                            content: property
                                          },
                                          {
                                            key: 'value',
                                            onClick: () => {
                                              copyToClipboard(value);
                                            },
                                            content: value
                                          }
                                        ]
                                      })}
                                      tableData={accountData}
                                    />
                                  )}
                                  {canViewAsCustomer && !isNew && (
                                    <>
                                      <Divider hidden />
                                      <Button
                                        onClick={() => {
                                          viewAsCustomer(customer);
                                        }}
                                        color="olive"
                                      >
                                        View as customer
                                      </Button>
                                    </>
                                  )}
                                  {canEdit && !isNew && isSignUp && brandedCustomerType(customerType) !== 'HOME' && (
                                    <>
                                      <Divider hidden />
                                      <Button
                                        onClick={() => {
                                          inviteCustomer(customer.id);
                                        }}
                                        color="olive"
                                      >
                                        Send Email Invite
                                      </Button>
                                    </>
                                  )}
                                  {canEdit && !isNew && customer.status === 'Signup' && (
                                    <>
                                      <Divider hidden />
                                      <Button
                                        onClick={() => {
                                          activateCustomer(customer.id);
                                        }}
                                        color="olive"
                                      >
                                        Activate Account
                                      </Button>
                                    </>
                                  )}
                                  {isNew && (
                                    <>
                                      <p
                                        sub
                                        color="grey"
                                        style={{
                                          marginTop: '15px',
                                          marginBottom: '5px'
                                        }}
                                      >
                                        <b>Account Type</b>
                                      </p>
                                      <Dropdown
                                        selection
                                        search
                                        options={customerTypes.map(t => {
                                          return {
                                            text: brandedCustomerType(t.name),
                                            value: t.name
                                          };
                                        })}
                                        onChange={(_, { value }) => {
                                          setCustomerType(value);
                                        }}
                                        value={customerType}
                                        disabled={!isNew}
                                      />
                                      {brandedCustomerType(customerType) === 'HOME' && (
                                        <>
                                          <p
                                            sub
                                            color="grey"
                                            style={{
                                              marginTop: '15px',
                                              marginBottom: '5px'
                                            }}
                                          >
                                            <b>Installation Supplement (£)</b>
                                          </p>
                                          <Input
                                            type="number"
                                            inputProps={{
                                              placeholder: 'Enter installation supplement'
                                            }}
                                            value={installationPaymentPounds}
                                            onChange={(_, { value }) => {
                                              setInstallationPaymentPounds(Math.max(parseInt(value), 0));
                                            }}
                                            disabled={!isNew}
                                          />
                                        </>
                                      )}
                                      <p
                                        sub
                                        color="grey"
                                        style={{
                                          marginTop: '15px',
                                          marginBottom: '5px'
                                        }}
                                      >
                                        <b>
                                        {['HOME'].includes(brandedCustomerType(customerType)) ? 'Initial Payment (£)' :
                                        ['HUB: Camden phase 1', 'HUB: Camden phase 2'].includes(brandedCustomerType(customerType)) ? 'Lance Deposit (£)' :
                                        ['HUB: Brent'].includes(brandedCustomerType(customerType)) ? 'Lance Deposit (£)' :
                                        ['HUB: Harrow', 'HUB: Bexley'].includes(brandedCustomerType(customerType)) ? 'Charging Credit (£)' :
                                        ['HUB: Barnet phase 1', 'HUB: Barnet phase 2'].includes(brandedCustomerType(customerType)) ? 'Charging Credit (£)' : ''}
                                        </b>
                                      </p>
                                      <Input
                                        type="number"
                                        inputProps={{
                                          placeholder: 'Enter initial payment'
                                        }}
                                        value={initialPaymentPounds}
                                        onChange={(_, { value }) => {
                                          setInitialPaymentPounds(Math.max(parseInt(value), 0));
                                        }}
                                        disabled={!isNew}
                                      />
                                      {brandedCustomerType(customerType) === 'HOME' ? (
                                        <>
                                          <p
                                            sub
                                            color="grey"
                                            style={{
                                              marginTop: '15px',
                                              marginBottom: '5px'
                                            }}
                                          >
                                            <b>Monthly Payment (£)</b>
                                          </p>
                                          <Input
                                            type="number"
                                            inputProps={{
                                              placeholder: 'Enter monthly payment'
                                            }}
                                            value={monthlyPaymentPounds}
                                            onChange={(_, { value }) => {
                                              setMonthlyPaymentPounds(Math.max(parseInt(value), 0));
                                            }}
                                            disabled={!isNew}
                                          />
                                          <p
                                            sub
                                            color="grey"
                                            style={{
                                              marginTop: '15px',
                                              marginBottom: '5px'
                                            }}
                                          >
                                            <b>Minimum Contract Term (months)</b>
                                          </p>
                                          <Input
                                            type="number"
                                            inputProps={{
                                              placeholder: 'Enter minimum term'
                                            }}
                                            value={minimumTermMonths}
                                            onChange={(_, { value }) => {
                                              setMinimumTermMonths(Math.max(parseInt(value), 0));
                                            }}
                                            disabled={!isNew}
                                          />
                                        </>
                                      ) : ''}
                                      <p
                                        sub
                                        color="grey"
                                        style={{
                                          marginTop: '15px',
                                          marginBottom: '5px'
                                        }}
                                      >
                                        <b>Email Address</b>
                                      </p>
                                      <FormikInput
                                        style={{ width: '200px' }}
                                        name="email"
                                        inputProps={{ placeholder: 'Enter email address' }}
                                        validate={value => (value ? null : 'Required')}
                                      />
                                      <p
                                        sub
                                        color="grey"
                                        style={{
                                          marginTop: '15px',
                                          marginBottom: '5px'
                                        }}
                                      >
                                        <b>Autofill details from Hubspot email</b>
                                      </p>
                                      <input placeholder="Paste email contents here" onPaste={handleHubSpotPaste} type="text" />
                                    </>
                                  )}
                                  {customer?.address_postcode && (
                                    <>
                                      <Divider hidden />
                                      <Button
                                        onClick={() => {
                                          history.push(`/admin/map?postcode=${customer.address_postcode}`);
                                        }}
                                        color="olive"
                                      >
                                        View home postcode on map
                                      </Button>
                                    </>
                                  )}
                                  {canDeactivate && ['Prospective', 'Active', 'Signup'].includes(customer?.status) && (
                                    <>
                                      <Divider hidden />
                                      <Button
                                        onClick={() => {
                                          setIsModalOpen(true);
                                        }}
                                        color="red"
                                        disabled={false/*hasActiveLance*/}
                                      >
                                        Deactivate account
                                      </Button>
                                    </>
                                  )}
                                </Grid.Column>
                              </Grid.Row>
                            </Grid>
                          </Segment>
                          {!isNew && (
                            <Segment>
                              <Grid columns={2}>
                                <Grid.Row>
                                  <Grid.Column>
                                    <Header as="h3">
                                      <Icon name="table" />
                                      Contract Terms & Preferences
                                    </Header>
                                    <Table
                                      basic="very"
                                      selectable
                                      stackable
                                      renderBodyRow={({ property, value }) => ({
                                        key: id,
                                        cells: [
                                          {
                                            key: 'property',
                                            onClick: () => {
                                              copyToClipboard(property);
                                            },
                                            content: property
                                          },
                                          {
                                            key: 'value',
                                            onClick: () => {
                                              copyToClipboard(value);
                                            },
                                            content: value
                                          }
                                        ]
                                      })}
                                      tableData={contractData}
                                    />
                                  </Grid.Column>
                                </Grid.Row>
                              </Grid>
                            </Segment>
                          )}
                          <Segment>
                            <Grid columns={1} divided stackable>
                              <Grid.Row>
                                <Grid.Column>
                                  <CustomerContact
                                    _handleSubmit={_handleSubmit}
                                    customer={customer}
                                    setFieldValue={setFieldValue}
                                    redactedForGDPR={false}
                                    copyDetails={true}
                                  />
                                </Grid.Column>
                              </Grid.Row>
                            </Grid>
                          </Segment>
                          <Segment>
                            <Grid columns={1} divided stackable>
                              <Grid.Row>
                                <Grid.Column>
                                  <Header as="h3">
                                    <Icon name="address card" />
                                    External Account
                                  </Header>
                                  <>
                                    <p
                                      sub
                                      color="grey"
                                      style={{
                                        marginTop: '15px',
                                        marginBottom: '5px'
                                      }}
                                    >
                                      <b>Company</b>
                                    </p>
                                    <Input
                                      type="text"
                                      inputProps={{
                                        placeholder: 'Company'
                                      }}
                                      name="externalCompanyId"
                                      value={externalCompanyId}
                                      onChange={(_, { value }) => {
                                        setExternalCompanyId(value);
                                        setCBTouched(true);
                                      }}
                                    />
                                    <p
                                      sub
                                      color="grey"
                                      style={{
                                        marginTop: '15px',
                                        marginBottom: '5px'
                                      }}
                                    >
                                      <b>Account number</b>
                                    </p>
                                    <Input
                                      type="text"
                                      inputProps={{
                                        placeholder: 'Account number'
                                      }}
                                      name="externalCompanyAccountNo"
                                      value={externalCompanyAccountNo}
                                      onChange={(_, { value }) => {
                                        setExternalCompanyAccountNo(value);
                                        setCBTouched(true);
                                      }}
                                    />
                                  </>
                                </Grid.Column>
                              </Grid.Row>
                            </Grid>
                          </Segment>
                          {!isNew && paysByCard && (
                            <Segment>
                              <Grid columns={1} divided stackable>
                                <Grid.Row>
                                  <Grid.Column>
                                    <CardDetails customerId={id} edit={false} />
                                  </Grid.Column>
                                </Grid.Row>
                              </Grid>
                            </Segment>
                          )}
                          <Segment>
                            <Grid columns={1} divided stackable>
                              <Grid.Row>
                                <Grid.Column>
                                  <Header as="h3">
                                    <Icon name="car" />
                                    Vehicle Details
                                  </Header>
                                  <>
                                    <p
                                      sub
                                      color="grey"
                                      style={{
                                        marginTop: '15px',
                                        marginBottom: '5px'
                                      }}
                                    >
                                      <b>Select Vehicle</b>
                                    </p>
                                    <Dropdown
                                      selection
                                      search
                                      options={vehicleOptions}
                                      onChange={(_, { value }) => {
                                        setCBTouched(true);
                                        setSelectedVehicle(value);
                                        selectVehicle(value);
                                      }}
                                      value={selectedVehicle}
                                    />
                                    <p
                                      sub
                                      color="grey"
                                      style={{
                                        marginTop: '15px',
                                        marginBottom: '5px'
                                      }}
                                    >
                                      <b>Make</b>
                                    </p>
                                    <Dropdown
                                      placeholder="Make"
                                      selection
                                      search
                                      options={makeOptions}
                                      onChange={(_, { value }) => {
                                        setCBTouched(true);
                                        setEditMake(value);
                                      }}
                                      value={editMake}
                                    />
                                    <p
                                      sub
                                      color="grey"
                                      style={{
                                        marginTop: '15px',
                                        marginBottom: '5px'
                                      }}
                                    >
                                      <b>Model</b>
                                    </p>
                                    <Dropdown
                                      placeholder="Model"
                                      selection
                                      search
                                      options={modelOptions}
                                      onChange={(_, { value }) => {
                                        setCBTouched(true);
                                        setEditModel(value);
                                      }}
                                      value={editModel}
                                    />
                                    <p
                                      sub
                                      color="grey"
                                      style={{
                                        marginTop: '15px',
                                        marginBottom: '5px'
                                      }}
                                    >
                                      <b>Variant</b>
                                    </p>
                                    <Dropdown
                                      placeholder="Variant"
                                      selection
                                      search
                                      options={variantOptions}
                                      onChange={(_, { value }) => {
                                        setCBTouched(true);
                                        setEditVariant(value);
                                        editVehicles[
                                          selectedVehicle
                                        ].vehicle_id = value;
                                      }}
                                      value={editVariant}
                                    />
                                    <p
                                      sub
                                      color="grey"
                                      style={{
                                        marginTop: '15px',
                                        marginBottom: '5px'
                                      }}
                                    >
                                      <b>Registration</b>
                                    </p>
                                    <Input
                                      type="text"
                                      inputProps={{
                                        placeholder: 'Vehicle Registration'
                                      }}
                                      name="editRegistration"
                                      onChange={(_, { value }) => {
                                        setCBTouched(true);
                                        setEditRegistration(value);
                                        editVehicles[
                                          selectedVehicle
                                        ].registration_no = value;
                                      }}
                                      value={editRegistration}
                                    />
                                    <br />
                                    <br />
                                    <br />
                                    <Button
                                      color="olive"
                                      onClick={() => {
                                        getVehicleDetails(editRegistration, false);
                                      }}
                                      disabled={!editRegistration}
                                    >
                                      Run DVLA Check
                                    </Button>
                                    <p
                                      sub
                                      color="grey"
                                      style={{
                                        marginTop: '15px',
                                        marginBottom: '5px'
                                      }}
                                    >
                                      <b>Tax Status</b>
                                    </p>
                                    <Input
                                      type="text"
                                      value={dvlaTax}
                                      disabled={true}
                                      style={{ width: '300px' }}
                                    />
                                    <p
                                      sub
                                      color="grey"
                                      style={{
                                        marginTop: '15px',
                                        marginBottom: '5px'
                                      }}
                                    >
                                      <b>MOT Status</b>
                                    </p>
                                    <Input
                                      type="text"
                                      value={dvlaMOT}
                                      disabled={true}
                                      style={{ width: '300px' }}
                                    />
                                  </>
                                </Grid.Column>
                              </Grid.Row>
                            </Grid>
                          </Segment>
                          <Segment>
                            <Grid columns={1} divided stackable>
                              <Grid.Row>
                                <Grid.Column>
                                  <Header as="h3">Notes</Header>
                                  <TextArea
                                    value={notes}
                                    onChange={(e, inputProps) => {
                                      setNotes(inputProps.value);
                                    }}
                                    style={{
                                      minHeight: 200
                                    }}
                                  />
                                </Grid.Column>
                              </Grid.Row>
                            </Grid>
                          </Segment>
                          </Form.Children>
                          <Button.Submit
                            style={{
                              width: '100%'
                            }}
                            primary
                            type="submit"
                            disabled={isSubmitting || !canEdit}
                            loading={isSubmitting}
                            color="olive"
                          >
                            {isNew ? 'Create Customer' : 'Save Details'}
                          </Button.Submit>
                        </div>
                      )}
                    </Form>
                  </Grid.Column>
                </Grid>
              </Tab.Pane>
            )
          },
          {
            menuItem: 'Charging History',
            render: () => (
              <Tab.Pane attached={false}>
                <Grid stretched>
                  <Grid.Row>
                    <Grid.Column>
                      <Header as="h2">Charging Sessions - {name}</Header>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Divider hidden />
                <Grid>
                  <Grid.Column width={3}>
                    <Grid.Row>
                      <Header as="h4">No. sessions</Header>
                      <Dropdown
                        selection
                        options={countOptions}
                        onChange={(_, { value }) => {
                          setNumSessions(value);
                        }}
                        value={numSessions}
                      />
                    </Grid.Row>
                  </Grid.Column>
                </Grid>
                <Grid>
                  <Table
                    basic="very"
                    selectable
                    stackable
                    headerRow={[
                      'Session Started',
                      'Session Ended',
                      'Location',
                      'Lance ID',
                      'Status',
                      'Charge Rate (kW)',
                      'Total Consumption (Wh)'
                    ]}
                    renderBodyRow={({
                      id,
                      start,
                      end,
                      timestamp,
                      stop_timestamp,
                      phalanx_tag_id,
                      location,
                      lance_serial_no,
                      status,
                      charge_rate,
                      total_consumption
                    }) => ({
                      key: id,
                      cells: [
                        {
                          key: 'start',
                          content: (
                            <>
                              <span
                                onClick={event => {
                                  history.push(`/admin/session/${id}`);
                                }}
                              >
                                {start}
                                {' '}
                              </span>
                              {currentUserCan('ManageGoogleCloud') && (
                                <img
                                  width={16}
                                  height={16}
                                  src="/images/gcp_logo.png"
                                  onClick={event => {
                                    goToCloudLogLink(phalanx_tag_id, timestamp);
                                  }}
                                  alt="Google Cloud logo"
                                />
                              )}
                            </>
                          )
                        },
                        {
                          key: 'end',
                          content: (
                            <>
                              <span
                                onClick={event => {
                                  history.push(`/admin/session/${id}`);
                                }}
                              >
                                {end}
                                {' '}
                              </span>
                              {currentUserCan('ManageGoogleCloud') && end && (
                                <img
                                  width={16}
                                  height={16}
                                  src="/images/gcp_logo.png"
                                  onClick={event => {
                                    goToCloudLogLink(phalanx_tag_id, stop_timestamp);
                                  }}
                                  alt="Google Cloud logo"
                                />
                              )}
                            </>
                          )
                        },
                        {
                          key: 'location',
                          onClick: () => {
                            history.push(`/admin/session/${id}`);
                          },
                          content: location
                        },
                        {
                          key: 'lance_serial_no',
                          onClick: () => {
                            history.push(`/admin/session/${id}`);
                          },
                          content: lance_serial_no
                        },
                        {
                          key: 'status',
                          onClick: () => {
                            history.push(`/admin/session/${id}`);
                          },
                          content: status
                        },
                        {
                          key: 'charge_rate',
                          onClick: () => {
                            history.push(`/admin/session/${id}`);
                          },
                          content: charge_rate.toFixed(0)
                        },
                        {
                          key: 'total_consumption',
                          onClick: () => {
                            history.push(`/admin/session/${id}`);
                          },
                          content: total_consumption
                        }
                      ]
                    })}
                    tableData={sessionData.length && sessionData}
                  />
                </Grid>
              </Tab.Pane>
            )
          },
          {
            menuItem: 'Lances',
            render: () => (
              <Tab.Pane attached={false}>
                <Grid stretched>
                  <Grid.Row>
                    <Grid.Column>
                      <Header as="h2">Customer Lance History</Header>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Divider hidden />
                <Grid>
                  <Table
                    basic="very"
                    selectable
                    stackable
                    headerRow={['Reference', 'From', 'To']}
                    renderBodyRow={({ lance_tag_id, from_datetime, to_datetime, status }) => ({
                      key: lance_tag_id,
                      cells: [
                        {
                          key: 'reference',
                          content: displayLanceIdAndStatus(lance_tag_id, to_datetime, status, lances)
                        },
                        {
                          key: 'from_datetime',
                          content: dbUTCDatetimeToLocal(from_datetime)
                        },
                        {
                          key: 'to_datetime',
                          content: dbUTCDatetimeToLocal(to_datetime)
                        }
                      ]
                    })}
                    tableData={customerToLances}
                  />
                </Grid>
              </Tab.Pane>
            )
          },
          {
            menuItem: 'Account Activity',
            render: () => (
              <Tab.Pane attached={false}>
                <Grid stretched>
                  <Grid.Row>
                    <Grid.Column>
                      <Header as="h2">Activity</Header>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Divider hidden />
                <Grid>
                  <Table
                    basic="very"
                    selectable
                    stackable
                    headerRow={['Timestamp', 'Activity', 'Notes']}
                    renderBodyRow={({ timestamp, activity, notes }) => ({
                      key: timestamp,
                      cells: [
                        {
                          key: 'timestamp',
                          content: pendingStatus(timestamp)
                        },
                        {
                          key: 'activity',
                          content: activity
                        },
                        {
                          key: 'notes',
                          content: notes
                        }
                      ]
                    })}
                    tableData={activity}
                  />
                </Grid>
              </Tab.Pane>
            )
          }
        ]}
      />
      <Modal
        open={isModalOpen}
        size="small"
        style={{ padding: '20px' }}
      >
        <Modal.Content>
          <Header as="h3">Deactivation Reason (max 250 chars)</Header>
          <TextArea
            value={deactivatedReason}
            onChange={(e, inputProps) => {
              setDeactivatedReason(inputProps.value);
            }}
            maxLength='250'
            style={{
              width: '100%',
              minHeight: 200
            }}
          />
          <br />
          <br />
          Are you sure you want to deactivate this customer account? {hasActiveLance ? 'NOTE: Customer still has a lance assigned.' : ''}
          <br />
          <br />
          <Button
            basic
            color="olive"
            onClick={event => {
              deactivateCustomer(customer.id);
              setIsModalOpen(false);
            }}
          >
            Yes
          </Button>
          <Button
            basic
            onClick={event => {
              setIsModalOpen(false);
            }}
          >
            No
          </Button>
        </Modal.Content>
      </Modal>
    </div>
  );
};
